// eslint-disable-next-line import/prefer-default-export
export const GESTION_MESSAGE = {
  messages: {
    prevention: 'Voulez-vous supprimer ce message ?',
    placeholder: 'Ecrivez un commentaire...',
    succesSave: 'Message sauvegardé avec succés',
    succesSuppression: 'Message supprimé avec succés',
  },
  button: {
    enregistrer: 'Enregistrer',
    annuler: 'Annuler les modifications',
    modifier: 'Modifier',
    supprimer: 'Supprimer',
  },
  actions: {
    afficher: 'Afficher les messages',
    masquer: 'Masquer les messages',
  },
  error: {
    emptyString: 'Ce champ ne peux pas être vide',
  },
};
